import React from "react";

// reactstrap components
import {
  Button,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
import LandingPageHeader from "components/Headers/LandingPageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

function LandingPage() {
  const [firstFocus, setFirstFocus] = React.useState(false);
  const [lastFocus, setLastFocus] = React.useState(false);
  React.useEffect(() => {
    document.body.classList.add("landing-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("landing-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);
  return (
    <>
      <ExamplesNavbar />
      <div className="wrapper">
        <LandingPageHeader />
        <div className="section section-about-us">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8" style={{ background: 'aliceblue' }}>
                <Row>
                  <Col md="3" style={{ alignSelf: 'center' }}>
                    <img src={require("assets/img/hero-image-1.png")} />
                  </Col>
                  <Col md="9" >
                    <h2 className="title">Who we are?</h2>
                    <h5 className="description">
                      <b>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</b>
                    </h5>
                  </Col>
                </Row>
              </Col>
            </Row>
            <div className="separator separator-primary"></div>
            <div className="section-story-overview">
              <Row>
                <Col md="6" style={{
                  marginBottom: '200px',
                }}>
                  <div
                    className="image-container image-left"
                    style={{
                      backgroundImage:
                        "url(" + require("assets/img/login.jpg") + ")",
                    }}
                  >
                    <p className="blockquote blockquote-info">
                      <b> "Our ultimate goal is to provide our clients with stress-free travel experiences that are both enjoyable and memorable. If you are looking for a reliable and experienced travel agency in Libya, look no further than us."</b> <br></br>
                      <br></br>
                      <small>-Husameddin Binfaid</small>
                    </p>
                  </div>
                </Col>
                <Col md="5">
                  <div
                    className="image-container image-right"
                    style={{
                      backgroundImage:
                        "url(" + require("assets/img/bg1.jpg") + ")"
                    }}
                  ></div>
                  <h3>
                    So what is your speciality ?
                  </h3>
                  <p>
                    We specialize in B2B travel services, and we have developed strong relationships with hotels, and other travel service providers to ensure that our clients receive the best rates and services. Our travel services include hotel reservations, transfers, tours, visa assistance, and much more.
                  </p>
                  <p>
                    At our travel agency, we are committed to providing exceptional customer service, and we take pride in going above and beyond to exceed our client's expectations.                   </p>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <div className="section section-team text-center" style={{ paddingTop: 0 }}>
          <Container>
            <h2 className="title">Here is our team</h2>
            <div className="team">
              {/* <Row>
                <Col md="4">
                  <div className="team-player">
                    <img
                      alt="..."
                      className="rounded-circle img-fluid img-raised"
                      src={require("assets/img/avatar-man.png")}
                    ></img>
                    <h4 className="title" style={{ marginTop: '12px' }}>Husameddin Binfaid</h4>
                    <p className="category text-info">C.E.O</p>
                  </div>
                </Col>
                <Col md="2">
                  <div className="team-player">
                    <img
                      alt="..."
                      className="rounded-circle img-fluid img-raised"
                      src={require("assets/img/avatar-man.png")}
                    ></img>
                    <h4 className="title" style={{ marginTop: '12px' }}>Abdulrazek Haitham</h4>
                    <p className="category text-info">Marketing</p>
                  </div>
                </Col>
                <Col md="2">
                  <div className="team-player">
                    <img
                      alt="..."
                      className="rounded-circle img-fluid img-raised"
                      src={require("assets/img/avatar-woman.png")}
                    ></img>
                    <h4 className="title" style={{ marginTop: '12px' }}>Haifa Agha</h4>
                    <p className="category text-info">Supervisor</p>
                  </div>
                </Col>
                <Col md="2">
                  <div className="team-player">
                    <img
                      alt="..."
                      className="rounded-circle img-fluid img-raised"
                      src={require("assets/img/avatar-woman.png")}
                    ></img>
                    <h4 className="title" style={{ marginTop: '12px' }}>Maha Eljhawi</h4>
                    <p className="category text-info">Auditing, Reviewing</p>

                  </div>
                </Col>
                <Col md="2">
                  <div className="team-player">
                    <img
                      alt="..."
                      className="rounded-circle img-fluid img-raised"
                      src={require("assets/img/avatar-woman.png")}
                    ></img>
                    <h4 className="title" style={{ marginTop: '12px' }}>Hulwah Elobaidi</h4>
                    <p className="category text-info">Help Desk</p>
                  </div>
                </Col>
              </Row> */}
            </div>
          </Container>
        </div>
        <div className="section section-contact-us text-center">
          <Container>
            <h2 className="title">Contact Us</h2>
            <p className="description">Ready for next trip?.</p>
            <form action="mailto:res@larocahotels.com" method="get" enctype="text/plain">
              <Row>
                <Col className="text-center ml-auto mr-auto" lg="6" md="8">
                  <InputGroup
                    className={
                      "input-lg" + (firstFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons users_circle-08"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="name"
                      name="subject"
                      type="text"
                      onFocus={() => setFirstFocus(true)}
                      onBlur={() => setFirstFocus(false)}
                    ></Input>
                  </InputGroup>
                  <div className="textarea-container">
                    <Input
                      cols="80"
                      name="body"
                      placeholder="Type a message..."
                      rows="4"
                      type="textarea"
                    ></Input>
                  </div>
                  <div className="send-button">
                    <Button
                      block
                      className="btn-round"
                      color="info"
                      type="submit"
                      size="lg"
                    >
                      Send Message
                    </Button>
                  </div>
                </Col>
              </Row>
            </form>
          </Container>
        </div>
        <DefaultFooter />
      </div >
    </>
  );
}

export default LandingPage;
